import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

interface StandardModalProps {
  title: string;
  children: React.ReactNode;
  open: boolean;
  handleClose: () => void;
  action: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  enableAutoFullscreen?: boolean; // 👈 Optional toggle
  secondaryAction?: React.ReactNode;
  fullScreen?: boolean;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
}

function StandardModal({
  title,
  children,
  open,
  handleClose,
  action,
  maxWidth = 'md',
  fullWidth = true,
  enableAutoFullscreen = true,
  secondaryAction,
  fullScreen: forceFullScreen = false,
  disableBackdropClick = false,
  disableEscapeKeyDown = false
}: StandardModalProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isFullScreen = (enableAutoFullscreen && isSmallScreen) || forceFullScreen;

  return (
    <Dialog
      open={open}
      onClose={disableBackdropClick ? undefined : handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      fullScreen={isFullScreen}
      onKeyDown={(e) => {
        if (disableEscapeKeyDown && e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {title}
          {isFullScreen && (
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          )}
          {secondaryAction && (
            secondaryAction
          )}
        </Box>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={action}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export default StandardModal;
